import { atom } from 'recoil';

export const forecastFiltersState = atom({
  key: 'forecast/filter/state',
  default: {},
});

export const forecastGroupIndexState = atom({
  key: 'forecast/group/index/state',
  default: null,
});

export const currentForecastState = atom({
  key: 'forecast/current/state',
  default: null,
});

export const changeMapState = atom({
  key: 'forecast/map/change',
  default: false,
});

export const openHolidayDialogState = atom({
  key: 'open-holidays-setting-dialog-state',
  default: false,
});

export const selectedRegionState = atom({
  key: 'forecast/selected/region/state',
  default: null,
});

export const statisticForecastState = atom({
  key: 'forecast/statistic/state',
  default: {},
});
